module.exports = __webpack_public_path__ + "img/icons8-landscape.3bc46024.svg";